import * as React from "react";
import { forwardRef } from "react";
const SvgWifi = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M50 14.623A70.75 70.75 0 0 0 0 35.377l9.095 9.095A57.9 57.9 0 0 1 50 27.487a57.9 57.9 0 0 1 40.905 16.985L100 35.377a70.75 70.75 0 0 0-50-20.754" />
    <path d="M50 35.528A49.85 49.85 0 0 0 14.774 50.15l9.095 9.095A37 37 0 0 1 50 48.392a37 37 0 0 1 26.13 10.854l9.096-9.095A49.85 49.85 0 0 0 50 35.528" />
    <path d="M50 56.432a28.95 28.95 0 0 0-20.452 8.493l9.083 9.083A16.08 16.08 0 0 1 50 69.296a16.08 16.08 0 0 1 11.37 4.712l9.082-9.083A28.95 28.95 0 0 0 50 56.432M50 77.337a8.04 8.04 0 0 0-5.678 2.361L50 85.377l5.678-5.679A8.04 8.04 0 0 0 50 77.337" />
  </svg>
);
const ForwardRef = forwardRef(SvgWifi);
export default ForwardRef;
